import { Component, EventEmitter } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators,  } from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";
import { ChangePasswordModel } from "@model/change-password.model";

@Component({
    templateUrl: "reset-password-modal.component.html",
    standalone: false
})
export class ResetPasswordModalComponent {
    title: string = "Reset Password";
    submitted: boolean = false;
    submitEvent: EventEmitter<any> = new EventEmitter();
    form: UntypedFormGroup;
    modalRef: BsModalRef;
    changePasswordModel : ChangePasswordModel ={};

    constructor(
        private bsModalRef: BsModalRef,
        private formBuilder: UntypedFormBuilder
        ) {
        this.modalRef = bsModalRef;
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({        
            newPassword: ['',[Validators.required,Validators.minLength(8)]],           
        });
      }
    
    onSubmit() {
        this.submitted = true;

        if (this.form.invalid ) {
            return;
        }

        
        this.modalRef.hide();
   
        this.submitEvent.emit( this.form.get("newPassword").value);
    }

    get f(): { [key: string]: AbstractControl; } {
        return this.form.controls;
      }
}